import SmiV2BaseApi from './smiV2BaseApi';


export default class SmiV2Twitter extends SmiV2BaseApi {
  postMedia({ user, token, formData }) {
    return fetch(`${this.smiv2ApiEndpoint}/v2/users/${user}/${this.serviceName}/upload`, {
      method: 'POST',
      headers: { token },
      body: formData,
    });
  }

  postTweet({ user, token, message, mediaId }) {
    return fetch(`${this.smiv2ApiEndpoint}/v2/users/${user}/${this.serviceName}/tweet`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        token,
      },
      body: JSON.stringify({
        message,
        media_id: mediaId,
      }),
    });
  }

  // unimplemented
  async getBroadcast({}) {}
  async postBroadcast({}) {}
  async patchBroadcast({}) {}
  async getStream({}) {}
}
